var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{staticClass:"breadcrumbs",attrs:{"parent":_vm.parentView}}),_c('v-row',[_c('v-col',{staticClass:"mt-10",attrs:{"cols":"12","md":"12"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }